<div class="layout-wrapper">
  <div class="empty-state">
    @if (imageSrc) {
      <div class="empty-state__image-wrapper">
        <img [src]="imageSrc" alt="No data" width="300" height="270"/>
      </div>
    }
    <div class="empty-state__section">
      <div class="empty-state__content">
        <h1>{{ title }}</h1>
        <p>{{ subtitle }}</p>
      </div>
      @if (showButton) {
        <app-button [disabled]="buttonDisabled()"
                    (onClick)="onClick()">
          {{ buttonText }}
        </app-button>
      }
    </div>
  </div>
</div>
